<template>
  <v-container
    fluid
    grid-list-md
    :class="{ 'fullscreen': fullscreen, 'grey lighten-5': fullscreen }"
  >
    <v-layout
      row
      wrap
    >

      <!-- Out of table toolbar -->
      <v-flex
        xs12
        text-xs-left
        v-if="showFullLayout && !hideExternalToolbar"
      >
        <v-btn
          flat
          color="primary"
          @click="initFilterStatus()"
        >
          <v-icon>remove_circle_outline</v-icon> נקה סינון
        </v-btn>

        <v-menu
          v-model="columnsMenu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-y
        >
          <v-btn
            slot="activator"
            flat
            color="primary"
          >
            <v-icon>view_column</v-icon> עמודות טבלה
          </v-btn>

          <v-card height="250px">
            <v-list>
              <v-list-tile
                v-for="(header, index) of headers"
                :key="`header${index}`"
                @click=""
              >
                <v-list-tile-action>
                  <v-checkbox
                    color="primary"
                    v-model="header.visible"
                  ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click="header.visible = !header.visible">
                  <v-list-tile-title>{{ header.text }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>

        <v-menu
          v-model="filterMenu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-y
        >
          <v-btn
            slot="activator"
            flat
            color="primary"
          >
            <v-icon>filter_list</v-icon> אפשרויות סינון
          </v-btn>

          <v-card height="250px">
            <v-list>
              <v-list-tile
                v-for="(filter, index) of filters.filter(filter => !filter.hidden)"
                :key="`header${index}`"
                @click=""
              >
                <v-list-tile-action>
                  <v-checkbox
                    color="primary"
                    v-model="filter.active"
                  ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click="filter.active = !filter.active">
                  <v-list-tile-title>{{ filter.label }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>

        <v-btn
          flat
          color="primary"
          @click="fullscreen = !fullscreen"
        >
          <v-icon>{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon> מסך מלא
        </v-btn>

        <!-- <v-btn
          flat
          color="primary"
          @click=""
        >
          <v-icon>mdi-download</v-icon> ייצוא
        </v-btn> -->
        <v-menu
          bottom
          right
        >
          <template v-slot:activator="{ on }">
            <v-btn
              flat
              color="primary"
              v-on="on"
              :loading="exporting"
            >
              <v-icon>mdi-download</v-icon> ייצוא
            </v-btn>
          </template>

          <v-list>
            <v-list-tile
              v-for="(item, i) in exportMenu"
              :key="i"
              @click="envokeMethodByName(item.click)"
            >
              <v-list-tile-title>
                <v-icon v-if="item.icon">{{ item.icon }}</v-icon> {{ item.title }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

      </v-flex>

      <!-- Filters -->
      <v-flex
        xs12
        v-if="showFullLayout"
      >
        <v-card>
          <v-card-title>
            <v-layout
              row
              wrap
            >

              <v-flex
                :xs12="!f.expanded"
                :md4="!f.expanded"
                :lg2="!f.expanded"
                v-for="(f, index) in filters.filter(filter => !filter.hidden)"
                :key="`f${index}`"
                v-if="f.active"
              >
                <!-- Text -->
                <v-text-field
                  v-if="f.type === 'TEXT'"
                  v-model="filterStatus[f.model]"
                  :append-icon="f.icon"
                  :label="f.label"
                  height="42px"
                ></v-text-field>

                <!-- Date -->
                <v-text-field
                  v-if="f.type === 'DATE'"
                  v-model="filterStatus[f.model]"
                  :append-icon="f.icon"
                  :label="f.label"
                  height="42px"
                  type="date"
                ></v-text-field>

                <!-- BOOLEAN -->
                <v-checkbox
                  v-if="f.type === 'BOOLEAN'"
                  v-model="filterStatus[f.model]"
                  :append-icon="f.icon"
                  :label="f.label"
                  height="42px"
                  type="date"
                  color="primary"
                ></v-checkbox>

                <!-- Combobox -->
                <v-combobox
                  v-if="f.type === 'COMBOBOX'"
                  :disabled="(f.dependsOn != undefined && filterStatus[f.dependsOn].length === 0)"
                  v-model="filterStatus[f.model]"
                  :items="getData(f.items)"
                  :item-text="f.itemText"
                  :item-value="f.itemValue"
                  :label="f.label"
                  multiple
                  chips
                  menu-props="right"
                >
                  <template
                    slot="selection"
                    slot-scope="{ item, index }"
                  >
                    <v-chip v-if="index <= 0">
                      <span>{{ item[f.itemText] }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="grey--text caption"
                    >(+{{ filterStatus[f.model].length - 1 }})</span>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>

      <!-- Table -->
      <v-flex xs12>
        <v-card>
          <v-data-table
            expand
            must-sort
            :headers="visibleHeaders"
            :rows-per-page-items="rowsPerPageItems"
            :items="items"
            item-key="_id"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <tr :class="{ 'light-green lighten-4 has-bottom-border': props.item[resource.highlightKey] }">
                <td
                  v-for="(header, index) in headers"
                  :key="`td${index}`"
                  v-if="isHeaderVisible(header.value)"
                >
                  <router-link
                    v-if="header.linkTo && header.linkTo(props.item)"
                    :to="header.linkTo(props.item)"
                    class="font-weight-bold"
                  >
                    {{ header.displayFunc(props.item, header.value) }}
                  </router-link>
                  <template v-else-if="header.type === 'ACTION'">
                    <v-btn
                      flat
                      icon
                      small
                      @click="doAction(header.click, props.item._id, header.name)"
                      :loading="actionLoaders[header.name + props.item._id]"
                    >
                      <v-icon>{{ header.icon }}</v-icon>
                    </v-btn>
                  </template>
                  <template v-else-if="header.type === 'CLICK'">
                    <a
                      class="font-weight-bold"
                      style="cursor: pointer; text-decoration: underline;"
                      @click.prevent="header.click && header.click(props.item)"
                    >
                      {{ header.displayFunc(props.item, header.value) }}
                    </a>
                  </template>
                  <template v-else-if="header.type === 'ICON'">
                    <v-icon small :color="header.displayFunc(props.item, header.value).color">
                      {{ header.displayFunc(props.item, header.value).icon }}
                    </v-icon>
                  </template>
                  <div
                    v-else
                    v-html="header.displayFunc(props.item, header.value)"
                  ></div>
                </td>
                <td
                  v-if="expand"
                  align="left"
                >
                  <v-btn
                    flat
                    icon
                    @click="props.expanded = !props.expanded"
                  >
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-card flat>
                <v-card-text :dir="expand.align === 'left' ? 'ltr' : 'rtl'">
                  <p :class="{ 'code-pre': expand.pre }">{{ expand.displayFunc(props.item, expand.value) }}</p>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import { format } from "date-fns";
import { throttle } from "lodash";
import Mixins from "@/mixins/mixins";
import { mapState, mapGetters } from "vuex";
import { setTimeout } from "timers";
import { getApi } from "../api";
import XLSX from "xlsx";

export default {
  data() {
    return {
      list: [],
      showFullLayout: true,
      fullscreen: false,
      columnsMenu: false,
      filterMenu: false,
      loading: true,
      actionLoaders: {},
      totalItems: 100000,
      exportMenu: [
        {
          title: "קובץ Excel",
          icon: "mdi-file-excel",
          click: "exportToExcel"
        },
        {
          title: "קובץ CSV",
          icon: "mdi-file-document",
          click: "exportToCsv"
        }
      ],
      pagination: {},
      defaultPagination: {
        sortBy: this.sortBy,
        descending: this.descending || false,
        rowsPerPage: this.defaultRowsPerPage || 50,
        page: 1
      },
      rowsPerPageItems: [
        5,
        10,
        25,
        50,
        200,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: "0" }
      ],
      filterStatus: {},
      exporting: false
    };
  },
  computed: {
    items() {
      let rows = this.list.map(
        id => this.$store.state.entities[this.resource.entityType][id]
      );
      const { sortBy, descending } = this.pagination || {};
      const sortHeader = (this.headers || []).find(header => header.value === sortBy);
      if (sortHeader && sortHeader.clientSort && typeof sortHeader.getSortKey === "function") {
        const dir = descending ? -1 : 1;
        rows = rows.slice().sort((a, b) => {
          const ka = sortHeader.getSortKey(a);
          const kb = sortHeader.getSortKey(b);
          if (ka < kb) return -1 * dir;
          if (ka > kb) return 1 * dir;
          return 0;
        });
      }
      return rows;
    },
    visibleHeaders() {
      let headers = this.headers.filter(item => {
        return item.visible;
      });

      if (this.expand) {
        headers.push(this.expand);
      }

      return headers;
    }
  },
  beforeMount() {
    this.setPaginationFromUrl();
    this.initFilterStatus();
    this.setFilterStatusFromUrl();
    this.setLayoutFromUrl();
  },
  methods: {
    format,
    doAction(func, id, actionName) {
      Vue.set(this.actionLoaders, actionName + id, true);
      func(id)
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          Vue.set(this.actionLoaders, actionName + id, false);
        });
    },
    envokeMethodByName(name) {
      this[name]();
    },
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    },
    getData(key) {
      return this.optionLists[key];
    },
    throttledGetDataFromApi: throttle(
      function(self) {
        self.getDataFromApi();
      },
      300,
      { leading: false, trailing: true, maxWait: 5000 }
    ),
    isHeaderVisible(value) {
      return this.headers.find(item => {
        return item.value === value;
      }).visible;
    },
    initFilterStatus() {
      for (let { type, model } of this.filters) {
        if (type === "COMBOBOX") {
          this.$set(this.filterStatus, model, []);
        } else {
          this.$set(this.filterStatus, model, null);
        }
      }
    },
    generateParams() {
      return Object.assign(
        this.generateResourceSpecificParams(),
        this.generatePaginationParams(),
        { fullscreen: this.fullscreen },
        { showFullLayout: this.showFullLayout }
      );
    },
    generateResourceSpecificParams() {
      let params = {};
      for (let { type, model } of this.filters) {
        let filterStatus = this.filterStatus[model];
        if (filterStatus) {
          if (type === "DATE") {
            params[model] = format(filterStatus, "YYYY-MM-DD");
          } else if (type === "COMBOBOX") {
            if (filterStatus.length) {
              params[model] = filterStatus
                .map(item => {
                  return item._id;
                })
                .reduce((prevValue, value) => prevValue + "," + value);
            }
          } else {
            params[model] = filterStatus;
          }
        }
      }

      const customQueryFilter = this.getCustomQueryFilter();
      if (customQueryFilter) {
        let existingQuery = {};
        if (params.q) {
          try {
            existingQuery =
              typeof params.q === "string" ? JSON.parse(params.q) : params.q;
          } catch (e) {
            existingQuery = {};
          }
        }
        params.q = JSON.stringify({
          ...existingQuery,
          ...customQueryFilter
        });
      }

      return params;
    },
    getCustomQueryFilter() {
      const filterFunc =
        typeof this.customQueryFilter === "function"
          ? this.customQueryFilter
          : typeof this.generateCustomQueryFilter === "function"
          ? this.generateCustomQueryFilter
          : null;
      if (filterFunc) {
        return filterFunc();
      }
      return null;
    },
    generatePaginationParams() {
      let params = {};
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      const sortHeader = (this.headers || []).find(header => header.value === sortBy);
      const effectiveSortBy =
        sortHeader && sortHeader.clientSort
          ? null
          : (sortHeader && sortHeader.sortValue) || sortBy;

      let sortParam = null;
      if (effectiveSortBy) {
        if (descending) {
          sortParam = `-${effectiveSortBy}`;
        } else {
          sortParam = `${effectiveSortBy}`;
        }
      }

      if (page && rowsPerPage) {
        params.skip = (page - 1) * rowsPerPage;
        params.limit = rowsPerPage;
      }

      if (sortParam) {
        params.sort = sortParam;
      }
      return params;
    },
    onEntitySaved({ entityType }) {
      if (this.resource && this.resource.entityType === entityType) {
        this.getDataFromApi();
      }
    },
    getDataFromApi() {
      this.loading = true;
      this.$store
        .dispatch("API_GET", {
          url: this.resource.endpoint,
          entityType: this.resource.entityType,
          schema: this.resource.listSchema,
          params: this.generateParams(),
          replace: true
        })
        .then(({ totalResults, list }) => {
          this.list = list;
          this.totalItems = totalResults;
          this.$emit("list-updated", list);
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.loading = false;
          this.updateUrlQuery();
        });
    },
    updateUrlQuery() {
      if (this.doNotSaveState) {
        return;
      }
      let query = Object.assign(
        this.updateResourceSpecificUrlQuery(),
        this.updatePaginationUrlQuery(),
        { fullscreen: this.fullscreen }
      );
      const extras =
        typeof this.queryExtras === "function"
          ? this.queryExtras()
          : this.queryExtras;
      if (extras) {
        query = Object.assign({}, query, extras);
      }
      this.$router.replace({ query });
    },
    updatePaginationUrlQuery() {
      let query = {};
      for (let key of Object.keys(this.pagination)) {
        let value = this.pagination[key];
        if (value) {
          query[key] = value;
        }
      }
      return query;
    },
    updateResourceSpecificUrlQuery() {
      let query = {};
      for (let { type, model } of this.filters) {
        let filterStatus = this.filterStatus[model];
        if (filterStatus) {
          if (type === "DATE") {
            query[model] = format(filterStatus, "YYYY-MM-DD");
          } else if (type === "COMBOBOX") {
            if (filterStatus.length) {
              query[model] = filterStatus
                .map(item => {
                  return item._id;
                })
                .reduce((prevValue, value) => prevValue + "," + value);
            }
          } else {
            query[model] = filterStatus;
          }
        }
      }
      return query;
    },
    setFilterStatusFromUrl() {
      for (let filter of this.filters) {
        let value = this.$route.query[filter.model];
        if (value) {
          if (filter.type === "COMBOBOX") {
            let arr;
            if (Array.isArray(value)) {
              arr = value;
            } else {
              arr = value.split(",");
            }
            this.filterStatus[filter.model] = arr
              .map(item => {
                return this.optionLists[filter.model].find(item2 => {
                  return item2._id === item;
                });
              })
              .filter(item => {
                return item;
              });
          } else {
            this.filterStatus[filter.model] = value;
          }
          filter.active = true;
        }
      }
    },
    setPaginationFromUrl() {
      let newPagination = Object.assign({}, this.defaultPagination);
      let page = this.$route.query.page;
      if (page) {
        newPagination.page = parseInt(page) || 1;
      }

      let rowsPerPage = this.$route.query.rowsPerPage;
      if (rowsPerPage) {
        newPagination.rowsPerPage = parseInt(rowsPerPage) || 5;
      }

      let sortBy = this.$route.query.sortBy;
      if (sortBy) {
        newPagination.sortBy = sortBy;
      }

      let descending = this.$route.query.descending;
      if (descending) {
        newPagination.descending = descending;
      }
      this.pagination = newPagination;
    },
    setLayoutFromUrl() {
      this.fullscreen = this.$route.query.fullscreen === "true";
      this.showFullLayout = this.$route.query.showFullLayout !== "false";
    },
    fetchReportData() {
      return new Promise((resolve, reject) => {
        let params = this.generateParams();
        params.skip = 0;
        params.limit = 0;
        this.$store
          .dispatch("API_GET", {
            url: this.resource.endpoint,
            entityType: this.resource.entityType,
            schema: this.resource.listSchema,
            params,
            replace: false
          })
          .then(({ list }) => {
            resolve(list);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    convertDataToTable(data) {
      let array = [];
      let headers = this.headers;
      for (let item of data) {
        let row = {};
        for (let header of headers) {
          row[header.text] = header.displayFunc(item, header.value);
        }
        array.push(row);
      }
      return array;
    },
    exportToExcel() {
      this.exportData({ type: "xlsx" });
    },
    exportToCsv() {
      this.exportData({ type: "csv" });
    },
    exportData({ type }) {
      this.exporting = true;
      this.fetchReportData()
        .then(list => {
          let data = list.map(
            id => this.$store.state.entities[this.resource.entityType][id]
          );
          let jsonTableData = this.convertDataToTable(data);
          var sheetData = XLSX.utils.json_to_sheet(jsonTableData);
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, sheetData, "Data");
          XLSX.writeFile(wb, `${this.resource.endpoint}.${type}`);
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.response ? err.response.data.message : err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.exporting = false;
        });
    }
  },
  watch: {
    pagination: {
      handler(val) {
        console.log(val);
        this.getDataFromApi();
      },
      deep: true
    },
    filterStatus: {
      handler(val) {
        console.log("watch filterStatus");
        this.getDataFromApi();
      },
      deep: true
    },
    fullscreen: function(val) {
      this.updateUrlQuery();
    }
  },
  mounted() {
    if (this.rowsPerPageItemsOverride) {
      this.rowsPerPageItems = this.rowsPerPageItemsOverride;
    }
    this.$bus.$on("entity-saved", this.onEntitySaved);
  },
  beforeDestroy() {
    this.$bus.$off("entity-saved", this.onEntitySaved);
  },
  props: [
    "headers",
    "filters",
    "sortBy",
    "descending",
    "resource",
    "optionLists",
    "expand",
    "doNotSaveState",
    "hideExternalToolbar",
    "rowAction",
    "defaultRowsPerPage",
    "customQueryFilter"
    ,
    "queryExtras"
  ],
  mixins: [Mixins]
};
</script>

<style scoped>
.code-pre {
  word-break: break-word;
  white-space: pre-wrap;
}

.has-bottom-border {
  border-top: 1px #fff solid !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AdvancedTable.vue